import { QRY_FLOW_LIST } from '../../config/stamp';
import { request, RespError, handleFormatRes, utf8to16 } from '../../utils';
// 需要转成 int 型的 key 数组
const needParseIntKey = ['count', 'exchPrizeCount'];
// 需要转成 date 型的 key 数组
const needParseDateKey = ['createTime'];
/**
 * 查询印花记录列表
 * @param options
 * @returns
 */
export async function qryFlowList(options) {
    const { pageSize: page_size = 20, pageNum: page_num = 0, orderType: order_type, startTime, endTime, qualId, } = options;
    try {
        const params = {
            t: +new Date(),
            page_size,
            page_num,
            qual_type_list: 1,
            order_type,
            start_time: parseInt(`${+startTime / 1000}`, 10),
            end_time: parseInt(`${+endTime / 1000}`, 10),
        };
        if (qualId) {
            // @ts-ignore
            params.qual_id = decodeURIComponent(qualId);
        }
        const result = await request.get(QRY_FLOW_LIST, { params });
        if (result) {
            if (+result.retcode) {
                throw new RespError(result.retcode, result.retmsg, result);
            }
            const res = handleFormatRes({ result, needParseIntKey, needParseDateKey });
            // base64处理
            if (res.flowList) {
                const flowListData = JSON.parse(utf8to16(atob(res.flowList)));
                res.flowList = flowListData.map(item => handleFormatRes({ result: item, needParseIntKey, needParseDateKey }));
            }
            return res;
        }
        throw result;
    }
    catch (e) {
        throw e;
    }
}
/**
 * 查询印花已储记录
 * @param options
 * @returns
 */
export async function qryEstampStoreList(options) {
    return qryFlowList(Object.assign(Object.assign({}, options), { orderType: '1' }));
}
/**
 * 查询印花兑换记录
 * @param options
 * @returns
 */
export async function qryEstampExchangeList(options) {
    return qryFlowList(Object.assign(Object.assign({}, options), { orderType: '2' }));
}
